import React, { useState, useEffect, useCallback, useContext  } from 'react';
import Etiqueta from './Etiqueta';
import { Get_type_tag_name } from '../Comun';
import { AuthContext } from '../contexts/AuthContext';
import { apiFetch } from '../utils/apiFetch';
import { useParams, useNavigate } from 'react-router-dom';

interface Tag 
{
  id: number;
  tag: string;
  valid_time: string;
  type_tag: number;
}

const Etiquetas: React.FC = () => 
{
  const { eventId, clientId } = useParams();
  const navigate = useNavigate();
  const eventIdNum = Number(eventId);
  const { token } = useContext(AuthContext);
  const [tags, setTags] = useState<Tag[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [selectedTag, setSelectedTag] = useState<Tag | null>(null);
  const [title, setEventName] = useState<string>('');
  
  //-----------------------------------------------------------

  const fetchTags = useCallback(async () => 
  {
    setLoading(true);
    try 
    {
      const response = await apiFetch(`web/get_event_tags?id_event=${eventId}&id_client=${clientId}`, {
        method: 'GET'
      });

      if (response.ok) 
      {
        const data = await response.json();
        setTags(data.tags);
        setEventName(data.eventName);
      } 
      else 
      {
        navigate('/main/not-found'); 
      }
    } 
    catch (error) 
    {
      const errorMsg = error instanceof Error ? error.message : 'Error desconocido';
      setError(errorMsg);
    } 
    finally 
    {
      setLoading(false);
    }
  }, [eventId, token]);

  //-----------------------------------------------------------

  useEffect(() => 
  {
    fetchTags();
  }, [fetchTags]);

  //-----------------------------------------------------------

  const handleCreateClick = () => 
  {
    setSelectedTag({
      id: -1,
      tag: '',
      valid_time: '',
      type_tag: 0
    });
  };

  //-----------------------------------------------------------

  const handleEditClick = (tag: Tag) => 
  {
    setSelectedTag(tag);
  };

  //-----------------------------------------------------------

  const handleFormClose = () => 
  {
    setSelectedTag(null);
    fetchTags();
  };

  //-----------------------------------------------------------

  return (
    <div className="eventos-container">
      <div className="miguitas">Etiquetas de {title}</div>

      {selectedTag === null ? (
        <div>

          {/* ── Toolbar ── */}
          <div className="cod-toolbar">
            <button className="icon-btn" onClick={() => navigate(`/main/recintos/${clientId}/eventos`)}>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <path d="M15 19l-7-7 7-7"/>
              </svg>
              Volver a Eventos
            </button>
            <div className="cod-toolbar__right">
              <button className="icon-btn icon-btn--create" onClick={handleCreateClick}>
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <path d="M12 5v14M5 12h14"/>
                </svg>
                Crear tag
              </button>
            </div>
          </div>

          {/* ── Estados ── */}
          {loading && <p>Buscando tags...</p>}
          {error && <p className="error-message">{error}</p>}
          {!loading && !error && tags.length === 0 && <p>No hay tags para mostrar.</p>}

          {/* ── Tabla ── */}
          {!loading && !error && tags.length > 0 && (
            <div className="table-scroll">
              <table className="eventos-table">
                <thead>
                  <tr>
                    <th>Etiqueta</th>
                    <th>Tipo</th>
                    <th>Tiempo válido</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {tags.map(tag => (
                    <tr key={tag.id}>
                      <td className="evento-name">{tag.tag}</td>
                      <td className="cod-muted-cell">{Get_type_tag_name(tag.type_tag)}</td>
                      <td className="cod-muted-cell">{tag.valid_time}</td>
                      <td className="evento-actions">
                        <button className="icon-btn icon-btn--edit" onClick={() => handleEditClick(tag)}>
                          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                          </svg>
                          Editar
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

        </div>
      ) : (
        <div className="form-overlay">
          <Etiqueta
            tag={selectedTag}  
            id_event={eventIdNum}
            onSave={handleFormClose}
            onCancel={handleFormClose}
            onDelete={(tagId) => {
              setTags(tags.filter(tag => tag.id !== tagId));
              handleFormClose();
            }}
          />
        </div>
      )}
    </div>
  );
};

export default Etiquetas;
